// Helpers genéricos p/ preparar dados para os charts

export const toNumber = (v) => (typeof v === "string" ? parseFloat(v) : v ?? 0);

// Ordena desc por 'value'
export const sortDescByValue = (arr) =>
  [...arr].sort((a, b) => toNumber(b.value) - toNumber(a.value));

// Pivot dia x fornecedores => [{data, FORN1: q, FORN2: q}]
export const pivotForStackedBars = (rows /* [{data,name,value}] */) => {
  const map = {};
  rows.forEach(({ data, name, value }) => {
    const d = data?.slice(0, 10) || data; // garante YYYY-MM-DD
    if (!map[d]) map[d] = { data: d };
    map[d][name] = toNumber(value);
  });
  return Object.values(map).sort((a, b) => (a.data > b.data ? 1 : -1));
};

export const unique = (arr) => Array.from(new Set(arr));

// Transforma analiseFornecedorDefeitos p/ ComposedChart
export const mapAnaliseComposta = (rows /* backend agregado */) =>
  rows.map((item) => ({
    name: item.fornecedor,
    totalNCEs: toNumber(item.totalNCEs ?? item.value ?? 0),
    qtdDefeitos: item.defeitos ? item.defeitos.split(",").length : 0,
    qtdUnidades: item.unidades ? item.unidades.split(",").length : 0,
    defeitos: item.defeitos || "",
    unidades: item.unidades || "",
  }));
